import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState, AppThunk } from '..';
import { AdminFilters } from '../../components/AdminFiltersControl';
import { StatisticsData, VideosAnalyticsData } from '../../generated-api';
import LimberAdminApi from '../../api/LimberAdminApi';

export interface StatisticsError {
}

export interface StatisticsState {
  loading: boolean;
  error: StatisticsError | null;
  filters: AdminFilters;
  statistics: StatisticsData | null;
  videoAnalytics: VideosAnalyticsData | null;
}

const initialState: StatisticsState = {
  loading: false,
  error: null,
  filters: {},
  statistics: null,
  videoAnalytics: null,
};

export const statisticsSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    startLoading: (state) => { state.loading = true; },
    loadingFailed: (state, action: PayloadAction<StatisticsError>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearError: (state) => { state.error = null; },

    setFilters: (state, action: PayloadAction<AdminFilters>) => {
      state.filters = action.payload;
    },

    loadStatisticsSucceeded: (state, action: PayloadAction<StatisticsData>) => {
      state.loading = false;
      state.error = null;
      state.statistics = action.payload;
    },
    loadVideoAnalyticsSucceeded: (
      state, action: PayloadAction<VideosAnalyticsData>,
    ) => {
      state.loading = false;
      state.error = null;
      state.videoAnalytics = action.payload;
    },
  },
});

const {
  startLoading, loadingFailed,
  loadStatisticsSucceeded, loadVideoAnalyticsSucceeded,
} = statisticsSlice.actions;
export const { clearError, setFilters } = statisticsSlice.actions;

export const loadStatistics = (
  getAccessToken: () => Promise<string>,
): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(startLoading());
    const accessToken = await getAccessToken();
    const api = new LimberAdminApi({ accessToken });
    const { filters } = getState().statistics;
    const statistics = await api.statisticsGet(filters);
    dispatch(loadStatisticsSucceeded(statistics));
  } catch (error) {
    console.error(error);
    dispatch(loadingFailed({
    }));
  }
};

export const loadVideoAnalytics = (
  getAccessToken: () => Promise<string>,
): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(startLoading());
    const accessToken = await getAccessToken();
    const api = new LimberAdminApi({ accessToken });
    const { filters } = getState().statistics;
    const videoAnalytics = await api.videoAnalyticsGet(filters);
    dispatch(loadVideoAnalyticsSucceeded(videoAnalytics));
  } catch (error) {
    console.error(error);
    dispatch(loadingFailed({
    }));
  }
};

export const selectStatistics = (state: RootState) => state.statistics;

export default statisticsSlice.reducer;
